import { j as S } from "../../../node_modules/react/jsx-runtime.js";
import { memo as J, useState as a, useRef as o, useEffect as R } from "react";
import v from "./ScrollBarContainer.module.scss.js";
import { clsx as K } from "../../../node_modules/clsx/dist/clsx.m.js";
const M = ({
  children: b,
  fade: y = !1,
  fadeSize: n = 40,
  // outerScrollBar = false,
  testId: H,
  width: E,
  height: A,
  maxHeight: B,
  minHeight: j,
  className: C,
  handleScrollEnd: u
}) => {
  const [x, W] = a(!1), [k, G] = a(!1), [I, N] = a(!1), [m, V] = a(!1), f = o(!0), g = o(!1), p = o(!0), d = o(!1), c = o(null), L = o({
    top: null,
    bottom: null,
    left: null,
    right: null
  }), h = o(null), T = o(0), e = (r, t) => {
    L.current[r] && (L.current[r].style.display = t ? "block" : "none");
  };
  function D(r) {
    const t = (r == null ? void 0 : r.scrollWidth) > (r == null ? void 0 : r.clientWidth), s = (r == null ? void 0 : r.scrollHeight) > (r == null ? void 0 : r.clientHeight);
    return {
      horizontalScroll: t,
      verticalScroll: s
    };
  }
  const q = D(c.current), $ = (r) => {
    const t = r.target;
    f.current = t.scrollTop === 0, g.current = t.scrollTop + t.clientHeight >= t.scrollHeight - 1, p.current = t.scrollLeft === 0, d.current = t.scrollLeft + t.clientWidth >= t.scrollWidth - 1, W(f.current), G(g.current), N(p.current), V(d.current), e("top", !f.current), e("bottom", !g.current), e("left", !p.current), e("right", !d.current), c.current && (c.current.classList.add(v.scrolling), h.current && clearTimeout(h.current), h.current = setTimeout(() => {
      var s, l, i;
      (i = (l = (s = c.current) == null ? void 0 : s.classList) == null ? void 0 : l.remove) == null || i.call(l, v.scrolling);
    }, 500));
  }, w = () => y ? {
    ...q.horizontalScroll ? {
      maskImage: `${!m && !I ? `linear-gradient(to right, #000, #000, transparent 0, #000 ${n}px, #000 calc(100% - ${n}px), transparent)` : `linear-gradient(${m ? "270deg" : "90deg"}, #000 calc(100% - ${n}px), transparent)`}`
      // maskImage: ,
    } : {
      maskImage: `${!x && !k ? `linear-gradient(rgba(27, 22, 22),transparent 0,rgba(27, 22, 22) ${n}px,rgba(27, 22, 22) calc(100% - ${n}px),transparent)` : `linear-gradient(${x ? "180deg" : "0deg"}, #000 calc(100% - ${n}px), transparent)`}`
    }
  } : {};
  return R(() => {
    if (c.current) {
      const r = c.current;
      return r.addEventListener("scroll", $), () => r.removeEventListener("scroll", $);
    }
  }, []), R(() => {
    if (u) {
      const r = () => {
        const s = c.current;
        if (s) {
          const { scrollTop: l, scrollHeight: i, clientHeight: F } = s;
          l !== T.current && l + F >= i - 1 && u(), T.current = l;
        }
      }, t = c.current;
      return t && t.addEventListener("scroll", r), () => {
        t && t.removeEventListener("scroll", r);
      };
    }
  }, [u]), /* @__PURE__ */ S.jsx("div", { className: "h-full", children: /* @__PURE__ */ S.jsx(
    "div",
    {
      ref: c,
      "data-testid": H,
      className: K(
        C,
        v.scrollContainer
        //   {
        //   [style.firefoxScrolling]: isFirefox || !outerScrollBar,
        // }
      ),
      style: { ...w(), width: E, height: A, maxHeight: B, minHeight: j },
      children: b
    }
  ) });
}, X = J(M);
export {
  X as default
};
//# sourceMappingURL=ScrollBarContainer.js.map
